var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.error.statusCode === 404)?_c('div',[_c('Page404')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }